// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__20yuG","fileBtn":"File_fileBtn__1auqD","closeBtn":"File_closeBtn__mnlhG","fileSelected":"File_fileSelected__axPhz","disabled":"File_disabled__1P0Sf"};